import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  ApproveShiftGQL,
  CancelWatchGQL,
  DeleteShiftAttachmentGQL,
  EnqueueShiftGQL,
  ExportWatchesToExcelGQL,
  FindWatchSubstituteGQL,
  ImportWatchesGQL,
  PauseShiftGQL,
  RejectShiftGQL,
  ShiftAttachmentsGQL,
  SkipShiftGQL,
  WatchesTableGQL,
} from '../../../generated/graphql';
import { Pagination } from '../../utils/Pagination';

@Injectable({
  providedIn: 'root',
})
export class WatchesService {
  constructor(
    private excelService: ExportWatchesToExcelGQL,
    private importService: ImportWatchesGQL,
    private listService: WatchesTableGQL,
    private findSubstituteService: FindWatchSubstituteGQL,
    private cancelWatchService: CancelWatchGQL,
    private approveShiftService: ApproveShiftGQL,
    private rejectShiftService: RejectShiftGQL,
    private shiftAttachmentsService: ShiftAttachmentsGQL,
    private deleteShiftAttachmentService: DeleteShiftAttachmentGQL,
    private skipShiftService: SkipShiftGQL,
    private pauseShiftService: PauseShiftGQL,
    private enqueueShiftService: EnqueueShiftGQL,
    private http: HttpClient
  ) {}

  exportToExcel(pagination: Pagination) {
    return this.excelService.fetch({ pagination });
  }

  import(excel: File) {
    return this.importService.mutate({ excel });
  }

  list(pagination: Pagination) {
    return this.listService.fetch({ pagination });
  }

  findSubstitute(watch: number) {
    return this.findSubstituteService.mutate({ watch });
  }

  cancelWatch(watch: number) {
    return this.cancelWatchService.mutate({ watch });
  }

  approveShift(shiftId: number) {
    return this.approveShiftService.mutate({ shiftId });
  }

  rejectShift(shiftId: number, reason: string | null) {
    return this.rejectShiftService.mutate({ shiftId, reason });
  }

  uploadShiftAttachment(shiftId: number, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`/api/shifts/${shiftId}/attachments`, formData);
  }

  getShiftAttachments(shiftId: number) {
    return this.shiftAttachmentsService.fetch({ shiftId });
  }

  deleteShiftAttachment(shiftId: number, attachmentId: number) {
    return this.deleteShiftAttachmentService.mutate({ shiftId, attachmentId });
  }

  skipShift(shiftId: number) {
    return this.skipShiftService.mutate({ shiftId });
  }

  pauseShift(shiftId: number) {
    return this.pauseShiftService.mutate({ shiftId });
  }

  enqueueShift(shiftId: number) {
    return this.enqueueShiftService.mutate({ shiftId });
  }
}
